import { useTranslation } from 'react-i18next';

import TitleStatusQuotation from './../components/title-status-quotation';
import Hr from '../../../components/Style/hr';

export default function ValidatedStepAcceptQuotation() {
    const { t } = useTranslation();

    return (
        <div className='px-4 md:px-0'>
            <TitleStatusQuotation title={t('pageQuotation.validated.title')} description={t('pageQuotation.validated.description')} />
            <Hr />
        </div>
    );
}